// import { LogLevel } from '@azure/msal-browser';

// Config object to be passed to Msal on creation
export const msalConfig = {
  auth: {
    clientId: '644715e6-d5fa-4244-bf3d-79a0d004b438',
    authority: 'https://login.microsoftonline.com/17191e81-857a-4080-81a2-7ea2401b34c1',
    redirectUri: '/',
    postLogoutRedirectUri: '/',
  },
  cache: {
    cacheLocation: 'localStorage',
  },
};

// Add here scopes for id token to be used at MS Identity Platform endpoints.
export const loginRequest = {
  scopes: ['User.Read'],
};
